<template>
  <div class="mt-5">
    <file-findings-table
      :file-findings="fileFindings"
      :file-findings-loading="fileFindingsLoading"
      :file-findings-total="fileFindingsTotal"
      @load-more="loadMoreItems"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, type PropType, ref, toRefs } from "vue";
import { storeToRefs } from "pinia";
import {
  type MspTicketDetails,
  useMspTicketsStore,
} from "@/_store/msp/tickets/msp-tickets.module.ts";
import FileFindingsTable from "@/components/tickets/ticket-preview-details/base-components/FileFindingsTable.vue";

export default defineComponent({
  components: {
    FileFindingsTable,
  },
  props: {
    ticket: {
      type: Object as PropType<MspTicketDetails>,
      required: true,
    },
  },
  setup(props) {
    const ticketStore = useMspTicketsStore();
    const { fullDetails } = storeToRefs(ticketStore);
    const { fileFindingsTotal, fileFindings, fileFindingsLoading } = toRefs(fullDetails.value);
    const page = ref(0);

    const getItems = async (virtualScroll = false) => {
      await ticketStore.getFileFindings({
        eventId: props.ticket.eventId,
        page: page.value,
        virtualScroll,
      });
    };

    onMounted(async () => {
      await getItems();
    });

    const loadMoreItems = () => {
      page.value += 1;
      getItems(true);
    };

    return {
      page,
      fileFindings,
      fileFindingsLoading,
      fileFindingsTotal,
      loadMoreItems,
    };
  },
});
</script>
